VLW.controllers.base_mc = class VLW_ContentController_base_mc extends VLW.ContentController {
	constructor(el, config) {
		super(el, config);
		this.autoVars();
		this.init_AttributeControllerClick();
		this.cptVlwScroll=0;
		TweenMax.set(this.mainElementJS, {opacity: 0});
		this._slider= [...this.mainElementJS.querySelectorAll(".vlw_slider")].map(function(elt){
			return new VLW.slider(elt, {mode: "slide", slideshowSpeed: 4000000, controlNav: true, directionNav: false, slideshow: true, touch: false})
		});
		this.mainElementJS.querySelectorAll("[data-style-background]")	.forEach(this.preloadHandler(this.onLoadBackgrounImage	,"data-style-background"));
		this.mainElementJS.querySelectorAll("[data-src]")				.forEach(this.preloadHandler(this.onLoadImage			,"data-src"));
		
		[...this.mainElementJS.querySelectorAll(".vlwCustomSelect")].forEach((el, index) => {
			//customSelect(el);
		});
	}
	qs(selector){
		return this.mainElementJS.querySelector(selector);
	}
	qsa(selector){
		return this.mainElementJS.querySelectorAll(selector);
	}
	preloadHandler(callBack,attribute){
		return (e)=>{
			let img    = new Image();
			img.elt    = e;
			img.onload = callBack;
			img.src    = e.getAttribute(attribute);
		}
	}
	onLoadBackgrounImage(e){
		e.currentTarget.elt.style.backgroundImage = "url(" + e.currentTarget.src + ")";
		e.currentTarget.elt.classList.add("_backgroundImageLoaded");
		e.currentTarget.elt = null;
	}
	onLoadImage(e){
		e.currentTarget.elt.setAttribute("src", e.currentTarget.src);
		e.currentTarget.elt.classList.add("_imageLoaded");
		e.currentTarget.elt = null;
	}
	clear_vlwScroll(){
		Object.entries(this).filter((elt)=>{return elt[0].match(/^myScroll/) && elt[1]!=null }).forEach((elt=>{
			elt[1].instanceClean && elt[1].instanceClean();
			this[elt[0]]=null;
		}));
	}
	init_vlwScroll(){
		[... this.mainElementJS.querySelectorAll(".vlwScroll")].forEach((elt,i)=>{
			if(!elt.vlwScrollBarInstance) {
				this["myScroll_" + this.cptVlwScroll] = new VLW.scrollBar(elt);
				this.cptVlwScroll++;
			}
		});
	}
	
	onRender(){
		this.init_vlwScroll();
		
		
	}

	autoVars() {
		[... this.mainElementJS.querySelectorAll('[controller-autoVars]')].forEach(e => {
			this[e.getAttribute("controller-autoVars")] = e;
		});
	}
	init_AttributeControllerClick() {
		[... this.mainElementJS.querySelectorAll('[controller-click]')].forEach(e => {
			e.addEventListener((e.getAttribute("controller-click-event") || EVENTS.EXTRACLICK), this.controller_action_onClick);
		});
	}
	clean_AttributeControllerClick() {
		[... this.mainElementJS.querySelectorAll('[controller-click]')].forEach(e => {
			e.removeEventListener((e.getAttribute("controller-click-event") || EVENTS.EXTRACLICK), this.controller_action_onClick);
		});
	}
	controller_action_onClick(e) {
		let method, scope, args, aArgs, jp;
		method = e.currentTarget.getAttribute('controller-click');
		if (args = e.currentTarget.getAttribute('controller-args')) {
			if (jp = JSON.parse(args)) {
				switch (true) {
					case (jp instanceof Array):
						aArgs = jp;
						break;
					case (typeof (jp) === "string"):
						aArgs = [jp];
						break;
					case (typeof (jp) === "object" && jp.event && jp.value && window[jp.event] && window[jp.event][jp.value]):
						aArgs = [window[jp.event][jp.value]];
						break;
					case (typeof (jp) === "object"):
						aArgs = [jp];
						break;
				}
			}
		} else {
			aArgs = [e];
		}
		if (!(scope = window[e.currentTarget.getAttribute('controller-scope')])) {
			scope = this;
		}
		if (scope[method]) {
			return scope[method].apply(scope, aArgs);
		}
	}

	intro() {
		TweenMax.to(this.mainElementJS,.5,{opacity:1});
		this.dispatchIntroComplete(.3);
	}

	outro(time=.5) {
		(this._slider && this._slider.forEach((elt)=>elt.instanceClean()));
		TweenMax.killDelayedCallsTo(this.mainElementJS);
		TweenMax.to(this.mainElementJS,time,{opacity:0});
		this.dispatchOutroComplete(time+.1);
	}

	dispatchIntroComplete(t) {
		setTimeout(()=> this.onIntroComplete && this.onIntroComplete() , t*1000);
	}
	dispatchOutroComplete(t) {
		setTimeout(()=>  this.onOutroComplete && this.onOutroComplete(), t*1000);
	}
	instanceClean() {
		this.clean_AttributeControllerClick();
		this.clicks = null;
	}
};
